import { SessionOrg, SessionUser } from '@/types/session.types';
import { NavigationItem } from '@/ui/Layout/Sidebar/NavigationItems/navigationItems';
import { hasPermission } from '@/utils/hubPermissions/hasPermissions';
import { isPermissionedRoute } from '@/utils/routing/routing';

function hasAccess(
  item: NavigationItem,
  user: SessionUser,
  org: SessionOrg
): boolean {
  if (item.isDrawer && item.items) {
    return item.items.some((subItem) => hasAccess(subItem, user, org));
  }

  if (item.specialConsideration) {
    return item.specialConsideration(item, user, org);
  }

  if (!item.url) {
    return (
      item.permission !== undefined &&
      hasPermission(user, item.permission) &&
      hasPermission(org, item.permission)
    );
  }

  return item.url ? isPermissionedRoute(item.url, user, org) : false;
}

function getItemsWithAccess(
  items: NavigationItem[],
  user: SessionUser,
  org: SessionOrg
): NavigationItem[] {
  return items
    .filter((item) => hasAccess(item, user, org))
    .map((item) => ({
      ...item,
      items: item.items ? getItemsWithAccess(item.items, user, org) : undefined,
    }));
}

export function filterNavItems(
  user: SessionUser,
  org: SessionOrg,
  navigationItems: NavigationItem[]
): NavigationItem[] {
  return getItemsWithAccess(navigationItems, user, org);
}
